import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import styled from 'styled-components';

import Navbar from './components/layout/Navbar';
import Home from './pages/Home';
import FooterNav from './components/layout/FooterNav';
import Spinner from './components/common/Spinner';
import NotFound from './pages/NotFound';
import MobileMenu from './components/layout/MobileMenu';
import Footer from './components/layout/Footer';
import ProductDetail from './components/products/ProductDetail';
import Cart from './components/cart/Cart';
import { CartProvider } from './context/CartContext';
import { CategoryProvider } from './context/CategoryContext';
import CategoryPage from './pages/CategoryPage';
import SpecialsPage from './pages/SpecialsPage';
import AboutUsPage from './pages/AboutUs';
import Checkout from './components/cart/Checkout';
import ThankYouPage from './pages/ThankYouPage';


const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const ContentWrap = styled.div`
  flex: 1 0 auto;
`;

const Main = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    });

    return () => clearTimeout(timer);
  }, [location]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const showToast = (message, type = 'success') => {
    toast[type](message, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  return (
    <PageContainer>
      <ContentWrap>
        <Navbar toggleMobileMenu={toggleMobileMenu} />
        {isLoading ? (
          <Spinner fullScreen />
        ) : (
          <Routes>
            <Route path="/" element={<Home showToast={showToast} />} />
            <Route path="/product/:slug" element={<ProductDetail showToast={showToast} />} />
            <Route path="/cart" element={<Cart showToast={showToast} />} />
            <Route path="/checkout" element={<Checkout showToast={showToast} />} />
            <Route path="/categories/:slug" element={<CategoryPage showToast={showToast} />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/specials" element={<SpecialsPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        )}
        <MobileMenu isOpen={isMobileMenuOpen} onClose={toggleMobileMenu} />
      </ContentWrap>
      <FooterNav toggleMobileMenu={toggleMobileMenu} />
      <Footer />
      <ToastContainer />
    </PageContainer>
  );
};

const App = () => {
  return (
    <Router>
      <CategoryProvider>
        <CartProvider>
          <Main />
        </CartProvider>
      </CategoryProvider>
    </Router>
  );
};

export default App;